import {
  add,
  remove,
  setActiveIndex,
  syncItems,
  types,
  update,
  updateOrder
} from "./actions"
import { getCurrentItemOrderIds } from "./utils"

export const getInitialState = (props) => {
  return {
    items: props.items,
    itemOrderIds: getCurrentItemOrderIds(props.items, []),
    activeIndex: 0,
    autoGenerateItem: props.autoGenerateItem,
    generateItem: props.generateItem,
    checkIsAutoGenerated: props.checkIsAutoGenerated,
    onSetActiveIndex: props.onSetActiveIndex,
    orderKey: props.orderKey,
    min: props.min,
    updateFunction: props.updateFunction
  }
}

export const reducer = (state, action) => {
  const { type, payload } = action

  switch (type) {
    case types.ADD_ITEM:
      return { ...state, ...add(payload, state) }
    case types.REMOVE_ITEM:
      return { ...state, ...remove(payload, state) }
    case types.UPDATE_ITEM:
      return { ...state, ...update(payload, state) }
    case types.UPDATE_ITEM_ORDER:
      return { ...state, ...updateOrder(payload, state) }
    case types.SET_ACTIVE_INDEX:
      return { ...state, ...setActiveIndex(payload) }
    case types.SYNC_ITEMS:
      return { ...state, ...syncItems(payload, state) }
    default:
      throw new Error(`Unknown action type in List: ${type}`)
  }
}
